export default (records, orderAttribute) => ({
    records,
    orderAttribute,
    handleReorderedRecords(elementList) {
        this.records = [...elementList]
            .map(li => li.attributes['x-sort:item'].value)
            .map((orderKey, index) => ({
                ...this.records[orderKey],
                [this.orderAttribute]: index + 1
            }));
    }
});
